"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import { FaLinkedinIn, FaTwitter, FaEnvelope } from "react-icons/fa6";
const TeamMemberCard = t0 => {
  const $ = _c(31);
  const {
    name,
    role,
    bio,
    image,
    delay
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 40
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    t3 = {
      once: true
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [0.16, 1, 0.3, 1];
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== delay) {
    t5 = {
      duration: 0.8,
      delay,
      ease: t4
    };
    $[4] = delay;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = `${name}, ${role}`;
  let t7;
  if ($[6] !== image || $[7] !== t6) {
    t7 = <img src={image} alt={t6} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 ease-out scale-[1.05] group-hover:scale-100 opacity-90 group-hover:opacity-100" />;
    $[6] = image;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="absolute inset-0 border border-[#C9A84C]/20 m-4 pointer-events-none transition-all duration-500 group-hover:m-0 group-hover:border-transparent" />;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== bio) {
    t9 = <p className="font-body text-[13px] text-white/70 leading-relaxed line-clamp-4 mb-6 italic font-light">"{bio}"</p>;
    $[10] = bio;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <a href="#" className="text-[#C9A84C] hover:text-white transition-colors"><FaLinkedinIn size={18} /></a>;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <a href="#" className="text-[#C9A84C] hover:text-white transition-colors"><FaTwitter size={18} /></a>;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="flex gap-4">{t10}{t11}<a href="#" className="text-[#C9A84C] hover:text-white transition-colors"><FaEnvelope size={18} /></a></div>;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t9) {
    t13 = <div className="absolute inset-0 flex flex-col justify-end p-8 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-[0.32, 0.72, 0, 1] bg-gradient-to-t from-[#0F1C2E] via-[#0F1C2E]/60 to-transparent">{t9}{t12}</div>;
    $[15] = t9;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t13 || $[18] !== t7) {
    t14 = <div className="relative aspect-[4/5] overflow-hidden bg-[#0F1C2E]">{t7}{t8}{t13}</div>;
    $[17] = t13;
    $[18] = t7;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== name) {
    t15 = <h3 className="font-display text-[20px] sm:text-[24px] text-[#F4EFE6] font-medium leading-tight mb-1 sm:mb-2 group-hover:text-[#C9A84C] transition-colors">{name}</h3>;
    $[20] = name;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== role) {
    t16 = <p className="font-body text-[11px] sm:text-[12px] tracking-[0.12em] sm:tracking-[0.15em] uppercase text-[#DF6D2A] font-light">{role}</p>;
    $[22] = role;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== t15 || $[25] !== t16) {
    t17 = <div className="mt-4 sm:mt-6">{t15}{t16}</div>;
    $[24] = t15;
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t14 || $[28] !== t17 || $[29] !== t5) {
    t18 = <motion.div initial={t1} whileInView={t2} viewport={t3} transition={t5} className="group relative">{t14}{t17}</motion.div>;
    $[27] = t14;
    $[28] = t17;
    $[29] = t5;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  return t18;
};
export default TeamMemberCard;